import { useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router'
import {
  mapLayersParam,
  panoFovParam,
  panoFullScreenParam,
  panoHeadingParam,
  panoPitchParam,
  panoTagParam,
} from '../../../../pages/MapPage/query-params'
import useBuildQueryString from '../../../hooks/useBuildQueryString'
import { PANO_LAYERS } from '../../../../pages/MapPage/components/PanoramaViewer/PanoramaViewer'
import useParam from '../../../hooks/useParam'
import { Variant } from '../../Button/Button'
import Icon from '../../Icon/Icon'
import { MapButton } from '../styles'
import Close from '../../../assets/icons/close.svg'

const PanoramaCloseButton = () => {
  const navigate = useNavigate()
  const browserLocation = useLocation()
  const { buildQueryString } = useBuildQueryString()
  const [activeLayers] = useParam(mapLayersParam)

  const activeLayersWithoutPano = useMemo(
    () => activeLayers.filter((id) => !PANO_LAYERS.includes(id)),
    [activeLayers],
  )

  const onClose = useCallback(() => {
    const { pathname } = browserLocation
    const queryString = buildQueryString(
      [[mapLayersParam, activeLayersWithoutPano]],
      [panoHeadingParam, panoPitchParam, panoTagParam, panoFovParam, panoFullScreenParam],
    )
    navigate(`${pathname}?${queryString}`)
  }, [browserLocation])

  return (
    <MapButton
      type="button"
      variant={Variant.PrimaryInverted}
      title="Panorama sluiten"
      size={44}
      onClick={onClose}
      data-testid="panoramaViewerCloseButton"
    >
      <Icon size={25}>
        <Close />
      </Icon>
    </MapButton>
  )
}

export default PanoramaCloseButton
